export default function generateTimeSlotsFunc() {
    const timeSlots: any = [];
    for (let hour = 9; hour < 23; hour++) {
        [0, 30].forEach(minute => {
            timeSlots.push(`${hour}:${minute === 0 ? "00" : minute}`);
        });
    }
    timeSlots.push("23:00");
    return timeSlots;
}
